import { render, staticRenderFns } from "./SendBackwradIcon.vue?vue&type=template&id=07398690&"
import script from "./SendBackwradIcon.vue?vue&type=script&lang=js&"
export * from "./SendBackwradIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports